module.exports = __webpack_public_path__ + "static/media/blogpagina_boom_detail_links.a2b579a3.svg";